import React, { PropsWithChildren } from 'react';
import styled from '@emotion/styled';

const PrintHidden_ = styled.div`
  @media print {
    display: none;
  }
`;

export const PrintHidden: React.FC<PropsWithChildren> = ({ children }) => (
  <PrintHidden_>{children}</PrintHidden_>
);
